import React, { createContext, Dispatch, useContext, useReducer } from "react";
import { IUserData } from "../../../../../interfaces/user/IUserData";

type BlogCoachCardContextProps = {
  state: BlogCoachCardState;
  dispatch: Dispatch<BlogCoachCardState>;
};

type BlogCoachCardState = {
  coach?: IUserData;
};

const BlogCoachCardContext = createContext<
  BlogCoachCardContextProps | undefined
>(undefined);

const blogCoachCardReducer = (
  newState: BlogCoachCardState,
  state: BlogCoachCardState,
): BlogCoachCardState => {
  return { coach: newState.coach ?? state.coach };
};

export const BlogCoachCardProvider = ({
  children,
  coach,
}: {
  children: React.ReactNode;
  coach: IUserData;
}) => {
  const initialState = {
    coach: coach,
  };

  const [state, dispatch] = useReducer(blogCoachCardReducer, initialState);

  return (
    <BlogCoachCardContext.Provider value={{ state, dispatch }}>
      {children}
    </BlogCoachCardContext.Provider>
  );
};

export const useBlogCoachCardContext = () => {
  const context = useContext(BlogCoachCardContext);

  if (!context) {
    throw new Error(
      "useBlogCoachCardContext must be used within a BlogCoachCardProvider",
    );
  }

  return context;
};
